// Find one: resolve single object by ID
export const findOneById = (items, id) => {
  return items.find(item => item.id === id);
};

// Find many: resolve multiple objects by array of IDs
export const filterManyByIds = (items, selectedIds) => {
  return items.filter(item => selectedIds.includes(item.id));
};
